<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Guardian Invite Info"
    seFeDataSubtitle="A guardian invite info component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for guardian invite info inputs</p>
      </se-fe-card-content>
    </se-fe-card>

    @for (n of models; track n) {
      <se-fe-card>
        <se-fe-card-header [seFeDataTitle]="n"></se-fe-card-header>
        <se-fe-card-content>
          <se-fe-docs-table
            [seFeDataHeaders]="headers[n]"
            [seFeDataRows]="rows[n]">
          </se-fe-docs-table>
        </se-fe-card-content>
      </se-fe-card>
    }

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-guardian-invite-info-example></se-po-guardian-invite-info-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
<se-fe-toast></se-fe-toast>
